module.exports = __webpack_public_path__ + "static/media/stop.982692f0.svg";